<template>
  <div class="omsPc">
    <p class="title">
      <img src="./img/MdTitle.png" alt="">
    </p>
    <div class="omsPCBox">
      <p class="titleImg"><img src="./img/MdContent1.png" alt=""></p>
      <p class="titleText">实现<span>订单归集、调度、费用核算</span>的统一管理 </p>
      <p class="contentText">三方物流管理系统是通过订单收集、智能调度、费用管控、统计报表等功能，对三方物流管理过程中的收单、调度、回单、费用核算管理等功能综合运用的管理系统，有效控制并跟踪订单作业和费用管理全过程，实现或完善企业的三方物流信息管理。</p>
      <p class="contentText">该系统不仅要执行三方物流过程中的所有实际操作，而且也需要与其他系统的数据对接，结合使用。</p>
      <p class="titleText"><span>OMS</span> 与 <span>WMS</span> 的 <span>分工</span></p>
      <p class="PcContent2"><img class="image" src="./img/MdContent2.png" alt=""></p>
      <p class="titleText">实现三方业务 <span>全链条的管理全覆盖，</span> 建立 <span>透明化一体化的OMS系统</span></p>
      <p class="PcContent3"><img class="image" src="./img/MdContent3.png" alt=""></p>
      <p class="titleText">时空OMS价值： <span>优化三方物流运营管理和执行</span></p>
      <p class="PcContent4"><img class="image" src="./img/MdContent4.png" alt=""></p>
      <p class="titleText"><span>时空OMS核心功能</span>  适应流通行业各种业务模式，实现三方物流全流程管理</p>
      <p class="PcContent5"><img class="image" src="./img/MdContent5.png" alt=""></p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// pc高度比
$md:72/192*2;
.omsPc{
  width: 750px/$md;
  // 标题
  .title{
    width: 100%;
    img{
      width: 100%;
    }
  }
  // 内容
  .omsPCBox{
    width: 750px/$md;
    margin: 0 auto;
    // 标题文字
    .titleText{
      width: 696px/$md;
      // height: 34px/$md;
      font-size: 28px/$md;
      margin: 0 auto;
      margin-bottom: 30px/$md;
      line-height: 40px/$md;
      span{
        color: red;
      }
    }
    // 文本文字
    .contentText{
      width: 696px/$md;
      font-size: 24px/$md;
      color: #666666;
      line-height: 50px/$md;
      margin: 0 auto;
      margin-bottom: 40px/$md;
    }
    // 标题图片
    .titleImg{
      width: 417px/$md;
      height: 107px/$md;
      margin: 50px/$md auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .PcContent2{
      width: 100%;
      height: 345px/$md;
      margin: 0 auto;
      margin-bottom: 50px/$md;
    }
    .PcContent3{
      width: 670px/$md;
      height: 324px/$md;
      margin: 0 auto;
      margin-bottom: 50px/$md;
    }
    .PcContent4{
      width: 696px/$md;
      height: 328px/$md;
      margin: 0 auto;
      margin-bottom: 50px/$md;
    }
    .PcContent5{
      width: 696px/$md;
      height: 267px/$md;
      margin: 0 auto;
      margin-bottom: 50px/$md;
    }
  }
}
.image{
  width: 100%;
  height: 100%;
}
</style>
